import React, { ReactNode } from 'react';

import SectionWrapper from 'components/layout/SectionWrapper';

interface ContainerProps {
  children: ReactNode;
}

const Container: React.FC<ContainerProps> = ({ children }) => (
  <SectionWrapper>
    <div className="mt-4">{children}</div>
  </SectionWrapper>
);

export default Container;
